module.exports = __webpack_public_path__ + "img/user-img.aefb4d91.png";